import { nonEmptyArray } from './nonEmptyArray';
/**
 * @since 0.5.7
 */
export function readonlyNonEmptyArray(codec, name) {
    if (name === void 0) { name = "ReadonlyNonEmptyArray<" + codec.name + ">"; }
    return nonEmptyArray(codec, name);
}
